if(typeof elastic-apm-node === 'undefined') { var e = new Error("Cannot find module 'elastic-apm-node'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = elastic-apm-node;